module.exports = __webpack_public_path__ + "img/double_tag_icon.c625bee8.png";